import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { SwipeableDrawer } from '@mui/material';

import PreviewInfosVertical from './PreviewInfosVertical';

const HighlightsDrawer = ({
    open,
    onClose,
    onSearch,
    previews = [],
    previewTitle,
    playbackOrigin,
}) => (
    <SwipeableDrawer
        anchor='bottom'
        open={open}
        onClose={onClose}
        onOpen={() => {}}
        disableDiscovery
        ModalProps={{ keepMounted: false }}
        PaperProps={{
            sx: {
                borderRadius: '18px 18px 0px 0px',
                maxHeight: 'calc(var(--app-drawer-height, 100vh) * 0.94)',
            },
        }}
    >
        <div className='highlightsDrawer horizontalCenter appDrawerSurface'>
            <div className='previewPreferenceDragIndicator' />
            <div className='highlightsDrawerHeader'>
                <h2 className='highlightsDrawerTitle'>Highlights</h2>
                <div className='highlightsDrawerHeaderActions'>
                    {onSearch && <button
                        type='button'
                        className='highlightsDrawerCloseButton'
                        onClick={onSearch}
                        aria-label='Search highlights'
                    >
                        <SearchRounded style={{ fontSize: '20px' }} />
                    </button>}
                    <button
                        type='button'
                        className='highlightsDrawerCloseButton'
                        onClick={onClose}
                        aria-label='Close highlights'
                    >
                        <CloseRounded style={{ fontSize: '20px' }} />
                    </button>
                </div>
            </div>
            <div className='highlightsDrawerDivider' />
            <div className='highlightsDrawerContent hideScrollbar'>
                <PreviewInfosVertical
                    previews={previews}
                    title={previewTitle || 'Highlights'}
                    playbackOrigin={playbackOrigin}
                    previewItemClassName='highlightsDrawerItem'
                />
            </div>
        </div>
    </SwipeableDrawer>
);

export default HighlightsDrawer;
